import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FileTextOutlined } from "@ant-design/icons";
import { Typography, theme } from "antd";
import { __, _i } from "../../../../../utils/i18n.js";
import { BillingAddressRestrictions } from "../../billingAddressRestrictions.js";
import { InfoCard } from "../../infoCard.js";
const BillingAddressInfoCard = ({ showTabLink = true })=>{
    const { token } = theme.useToken();
    return /*#__PURE__*/ _jsxs(InfoCard, {
        variant: "primary-soft",
        icon: /*#__PURE__*/ _jsx(FileTextOutlined, {
            style: {
                color: token.colorPrimary
            }
        }),
        heading: __("Billing address & VAT number"),
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "rc-account-v2-info-card-para",
                style: {
                    color: token.colorText
                },
                children: __("Billing details are set per subscription, not account-wide.")
            }),
            /*#__PURE__*/ _jsxs("ol", {
                className: "rc-account-v2-info-card-list rc-account-v2-info-card-list--ordered",
                style: {
                    color: token.colorText
                },
                children: [
                    showTabLink && /*#__PURE__*/ _jsx("li", {
                        children: _i(__('Open the {{tab}}"Invoices" tab{{/tab}}.'), {
                            tab: /*#__PURE__*/ _jsx(Typography.Link, {
                                href: "#/invoices"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        children: __("Open the latest invoice for that subscription.")
                    }),
                    /*#__PURE__*/ _jsx("li", {
                        children: __("Click 'Add address & VAT number' or 'Edit address / add VAT number' (personal) or 'Edit business address' (company/organization).")
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "rc-account-v2-info-card-note",
                style: {
                    color: token.colorTextSecondary
                },
                children: __("The updated address applies to this invoice and all future ones. To update your address for upcoming invoices, wait for the next invoice to be issued and open it here.")
            }),
            /*#__PURE__*/ _jsx(BillingAddressRestrictions, {})
        ]
    });
};
export { BillingAddressInfoCard };
